/**
 * 选择商品
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import { groupBy } from 'lodash';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';

interface ClassInfo {
  parentName?: string;
  isSelected?: boolean;
  className?: string;
  classId?: number;
  classSort?: number;
  classState?: number;
  parentId?: number;
  children?: ClassInfo[];
}

enum SELECT_TYPE {
  FIRST_Multiple_SECOND_Multiple = 1,
  FIRST_Multiple_SECOND_Single,
  FIRST_Single_SECOND_Multiple,
  FIRST_Single_SECOND_Single,
}

@DialogFactory
@Component({
  mixins: [style],
  components: {},
})
export default class ChooseGoosClass extends IPSDialog {
  title = '请选择分类';

  width = '800px';

  /**
   * 变量
   */

  // 一级分类 第一列
  firstLevelClass: ClassInfo[] = [];

  // 二级分类 第二列
  secondLevelClass: ClassInfo[] = [];

  // 选择的分类 第三列
  selectedClass: ClassInfo[] = [];

  /**
   * 外部参数
   */

  // 已选择分类传参
  selected: number[] = [];

  // 数据源 当有数据源时不需要再调用接口获取值
  dataSource = [];

  // 网点Id 当有数据源的时候可不传 反之必传
  siteId = 0;

  /**
   * 选择方式
   * 1 一级分类可多选 二级分类也可以多选
   * 2 一级可以多选 二级不可多选
   * 3 一级分类不可多选 二级分类可多选
   * 4 一级分类和二级分类只能单选
   * @type {number}
   */
  selectType = 1;

  /**
   * 计算属性
   */

  getSelectedFirstClass() {
    return this.firstLevelClass.find(v => v.isSelected) || {};
  }

  getSelectedSecondClass() {
    return this.secondLevelClass.filter(v => v.isSelected);
  }

  async mounted() {
    this.firstLevelClass = this.dataSource && this.dataSource.length ? this.dataSource : await this.getClassList();
    this.resetState();
    const childrenStore = this.firstLevelClass.flatMap(v => v.children);
    const childrenList = childrenStore.filter(v => this.selected.includes(v.classId));
    const resultGroup = groupBy(childrenList, 'parentId');
    this.selectedClass = Object.keys(resultGroup).map((k) => {
      const parent = this.firstLevelClass.find(v => v.classId == Number(k));
      return Object.assign({}, { ...parent }, { children: resultGroup[k] });
    });
  }

  getClassList() {
    return IPSService.siteClassList({
      postParams: {
        siteId: this.siteId,
      },
    }).then((response) => {
      return (response.list || []).map((v) => {
        if (v.children) {
          v.children = v.children.map((val) => {
            v.parentName = v.className;
            return { ...val, isSelected: false };
          });
        }
        return { ...v, isSelected: false };
      });
    });
  }

  getResults() {
    return this.selectedClass
      .flatMap((v) => {
        return v.children.map(vc => vc.classId);
      });
  }

  onConfirm() {
    if (!this.getResults() || !this.getResults().length) {
      this.$message.warning('请选择分类');
    } else {
      this.$emit('result', this.getResults());
      this.$emit('hidden');
    }
  }

  // 一级分类选择
  chooseFirstClass(i) {
    switch (this.selectType) {
      case SELECT_TYPE.FIRST_Multiple_SECOND_Multiple:
        if (!this.firstLevelClass[i].isSelected) {
          this.resetState();
          this.firstLevelClass[i].isSelected = true;
          this.secondLevelClass = this.firstLevelClass[i].children;
          const selected = this.selectedClass.find(v => v.classId === this.firstLevelClass[i].classId);
          if (selected && selected.children) {
            const selectedCode = selected.children.map(v => v.classId);
            this.secondLevelClass = this.secondLevelClass.map((v) => {
              return Object.assign(v, { isSelected: selectedCode.includes(v.classId) });
            });
          }
        }
        break;
      case SELECT_TYPE.FIRST_Multiple_SECOND_Single:
        if (!this.firstLevelClass[i].isSelected) {
          this.resetState();
          this.firstLevelClass[i].isSelected = true;
          this.secondLevelClass = this.firstLevelClass[i].children;
          const selected = this.selectedClass.find(v => v.classId === this.firstLevelClass[i].classId);
          if (selected && selected.children) {
            const selectedCode = selected.children.map(v => v.classId);
            this.secondLevelClass = this.secondLevelClass.map((v) => {
              return Object.assign(v, { isSelected: selectedCode.includes(v.classId) });
            });
          }
        }
        break;
      case SELECT_TYPE.FIRST_Single_SECOND_Multiple:
        break;
      case SELECT_TYPE.FIRST_Single_SECOND_Single:
        break;
      default:
        break;
    }
    this.$forceUpdate();
  }

  // 二级分类选择
  chooseSecondClass(i) {
    switch (this.selectType) {
      case SELECT_TYPE.FIRST_Multiple_SECOND_Multiple:
        this.secondLevelClass[i].isSelected = !this.secondLevelClass[i].isSelected;
        break;
      case SELECT_TYPE.FIRST_Multiple_SECOND_Single:
        this.secondLevelClass = this.secondLevelClass.map((v, index) => {
          v.isSelected = index === i;
          return v;
        });
        break;
      case SELECT_TYPE.FIRST_Single_SECOND_Multiple:
        break;
      case SELECT_TYPE.FIRST_Single_SECOND_Single:
        break;

      default:
        break;
    }
    this.$forceUpdate();
  }

  // 清除全部
  clearAll() {
    this.selectedClass = [];
  }

  // 加入
  onJoin() {
    const joinClass = this.selectedClass.find(v => v.classId === this.getSelectedFirstClass().classId);
    switch (this.selectType) {
      case SELECT_TYPE.FIRST_Multiple_SECOND_Multiple:
        if (joinClass) {
          const joined = joinClass.children.map(v => v.classId);
          // 全不选就是全选
          let children = [];
          if (!this.getSelectedSecondClass().length) {
            children = this.secondLevelClass;
          } else {
            children = this.getSelectedSecondClass();
          }
          joinClass.children = children;
        } else {
          let children = [];
          if (!this.getSelectedSecondClass().length) {
            children = this.secondLevelClass;
          } else {
            children = this.getSelectedSecondClass();
          }
          this.selectedClass.push({
            parentName: this.getSelectedFirstClass().parentName,
            parentId: this.getSelectedFirstClass().parentId,
            classId: this.getSelectedFirstClass().classId,
            className: this.getSelectedFirstClass().className,
            isSelected: false,
            children,
          });
        }
        break;
      case SELECT_TYPE.FIRST_Multiple_SECOND_Single:
        if (joinClass) {
          let isEqual = false;
          if (joinClass.children && joinClass.children[0] && this.getSelectedSecondClass() && this.getSelectedSecondClass()[0]) {
            isEqual = joinClass.children[0].classId != this.getSelectedSecondClass()[0].classId;
            if (isEqual) {
              this.$confirm(`${joinClass.className}下已存在${joinClass.children[0].className},是否替换?`, {
                type: 'warning',
              }).then((result) => {
                if (result === 'confirm') {
                  joinClass.children = this.getSelectedSecondClass();
                }
              });
            }
          } else {
            joinClass.children = this.getSelectedSecondClass();
          }
        } else {
          this.selectedClass.push({
            parentName: this.getSelectedFirstClass().parentName,
            parentId: this.getSelectedFirstClass().parentId,
            classId: this.getSelectedFirstClass().classId,
            className: this.getSelectedFirstClass().className,
            isSelected: false,
            children: this.getSelectedSecondClass(),
          });
        }
        break;
      case SELECT_TYPE.FIRST_Single_SECOND_Multiple:
        break;
      case SELECT_TYPE.FIRST_Single_SECOND_Single:
        break;

      default:
        break;
    }
  }

  // 移除
  onRemove(i) {
    this.selectedClass.splice(i, 1);
  }

  resetState() {
    this.firstLevelClass = this.firstLevelClass.map((v) => {
      if (v.children) {
        v.children = v.children.map((vc) => {
          return Object.assign(vc, { isSelected: false });
        });
      }
      return Object.assign(v, { isSelected: false });
    });
  }

  getDisabled() {
    let result = false;
    switch (this.selectType) {
      case SELECT_TYPE.FIRST_Multiple_SECOND_Multiple:
        result = !this.secondLevelClass || !this.secondLevelClass.length;
        break;
      case SELECT_TYPE.FIRST_Multiple_SECOND_Single:
        result = !this.getSelectedSecondClass() || !this.getSelectedSecondClass().length;
        break;
      default:
        break;
    }
    return result;
  }

  renderContent(h) {
    return (
      <el-row class="class-container">
        <el-col span={7} class="first-level">
          <div class="level-title">一级分类</div>
          <div class="class-list">
            {this.firstLevelClass.map((v, i) => {
              return (
                <div key={i} onClick={this.chooseFirstClass.bind(this, i)} class={[v.isSelected && 'selected', 'class-item']}>
                  {v.className}
                </div>
              );
            })}
          </div>
        </el-col>
        <el-col span={7} class="second-level">
          <div class="level-title">二级分类</div>
          <div class="class-list">
            {this.secondLevelClass.map((v, i) => {
              return (
                <div key={i} onClick={this.chooseSecondClass.bind(this, i)} class={[v.isSelected && 'selected', 'class-item']}>
                  {v.className}
                </div>
              );
            })}
          </div>
        </el-col>
        <el-col class="second-join" span={3}>
          <el-button type="primary" onClick={this.onJoin.bind(this)} disabled={this.getDisabled()}>
            加入
          </el-button>
        </el-col>
        <el-col span={7} class="selected-class">
          <div class="level-title">
            <span>已选分类</span>
            <span class="selected" onClick={this.clearAll.bind(this)}>
              清除全部
            </span>
          </div>
          <div class="class-list">
            {this.selectedClass.map((v, i) => {
              return (
                <div class="selected-item">
                  <el-tooltip class="item" effect="light" content={`${v.className}/${v.children.map(vc => vc.className).join('、')}`} placement="top">
                    <div class="class-name" key={i}>
                      {`${v.className}/${v.children.map(vc => vc.className).join('、')}`}
                    </div>
                  </el-tooltip>
                  <div class="remove-x selected" onClick={this.onRemove.bind(this, i)}>
                    X
                  </div>
                </div>
              );
            })}
          </div>
        </el-col>
      </el-row>
    );
  }
}
